var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"clickable":"","left-arrow":"","safe-area-inset-top":"","border":false,"title":_vm.title,"placeholder":""},on:{"click-left":_vm.onClickLeft}})
}
var staticRenderFns = []

export { render, staticRenderFns }